<div class="container-question flex space-x-3 mt-8 mb-2.5">
  <div *ngIf="question" class="title-question inline-block align-middle my-auto">
    <span [innerHTML]="question.libelle" class="whitespace-pre-line"></span>
    <app-popup-info *ngIf="question.popupInfo" [popUpInfo]="question.popupInfo"></app-popup-info>
  </div>
</div>
